import './App.css';
import AllRounts from './Compnents/Additinal/AllRounts';

function App() {
  return (
    <div className="App">
      <AllRounts/>
    </div>
  );
}

export default App;
